function CounterOne() {
    let count = 0;

    const increment = () => {
        // count = count + 1;
        // count += 1;
        count ++;
        printCount();
    }

     const decrement = () => {
        // count = count - 1;
        // count -= 1;
        count --;
        printCount();
    }

    const printCount = () => {
        console.log(count);
    }

    return (
        <section>
            <h2>Updating variable (count) without using state (Bad Practice)</h2>
            <div className="counter">
                <input type="button" value="Minus" onClick={decrement}/>
                <input type="text" value={count} readOnly />
                <input type="button" value="Plus" onClick={increment}/>
            </div>
        </section>
    );
}

export default CounterOne;